import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const SelectRange = ({selectRange,ranges,value}) => {
  return (
    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{zIndex:'2'}}>
      <label htmlFor="select">Show Payments From</label>
      <Select
        id="select"
        onChange={selectRange}
        valueKey="value"
        value={value}
        options={ranges}
        clearable={false}
      />
    </div>
  )
};

SelectRange.propTypes = {
  selectRange: PropTypes.func.isRequired,
  ranges: PropTypes.array.isRequired
};
SelectRange.defaultProps = {};

export default SelectRange;


// WEBPACK FOOTER //
// ./src/components/SelectRange.jsx